import type { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge";
import { NavigationTypes } from "@swiggy-private/native-bridge";
import { isApp } from "@swiggy-private/portal-dineout-context";
import { getBridgeSdk } from "./bridgeSdk";
import { isIOS } from "./browser";

export const closeWebview = () => {
    getBridgeSdk()
        .close()
        .catch(() => void 0);
};

const DIGITAL_MENU_DEEPLINK = "swiggydiners://digital-menu";

export const navigateToDigitalMenu = (restaurantId: string, tableId: string, userJourney?: string) => {
    const deeplink = `${DIGITAL_MENU_DEEPLINK}/${restaurantId}/${tableId}`;
    const params: Record<string, string> = { shouldCloseWebview: "true" };

    if (isIOS()) {
        params.shouldReplacePreviousWebview = "true";
    }

    if (userJourney) {
        params.userJourney = userJourney;
    }

    getBridgeSdk()
        .navigateToScreen({
            type: NavigationTypes.DEEPLINK,
            link: deeplink,
            params,
        })
        .catch(() => void 0);
};

let swHeaders: GetSwiggyHeadersResponsePayload | undefined;

export const getSwiggyHeaders = async (clearCache = false): Promise<GetSwiggyHeadersResponsePayload | undefined> => {
    // swHeaders is already initialized
    if (swHeaders && !clearCache) {
        return swHeaders;
    }

    // get header value, store & return
    if (isApp()) {
        swHeaders = await getBridgeSdk().getSwiggyHeadersFromClient();
    } else {
        try {
            swHeaders = JSON.parse(localStorage.getItem("swiggy_auth_headers") || "{}");
            return swHeaders;
        } catch (_e) {
            return {} as GetSwiggyHeadersResponsePayload;
        }
    }

    return swHeaders;
};

export const isAndroidPlatform = (platform: string): boolean => {
    const platformKey = platform.toLowerCase();
    return platformKey === "swiggy-android" || platformKey === "an";
};

export const getUserHeaders = () => {
    if (swHeaders) {
        return {
            tid: swHeaders.tid,
            sid: swHeaders.sid,
            deviceId: swHeaders.deviceId,
            token: swHeaders.token,
            versionCode: swHeaders["version-code"],
        };
    }
};
